import React from 'react';

import Anchors from '@scripts/utilities/anchors.js';
import AnalyticsUtil from '@scripts/utilities/analytics.js';


/**
 * Track all clicks within this component that are external, and log them to the
 * analytics object.
 */
class OutboundLinkTracker extends React.Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick(event) {
    var target = event.target;
    var anchor = target.closest('a');

    if (anchor) {
      if (Anchors.isExternal(anchor)) {
        this.logClick(event, anchor);

        // prevent the click from 'bubbling' to the top of the document, where
        // we have a separate event listener to catch all miscellaneous clicks.
        event.stopPropagation();
      }
    }
  }

  logClick(event, anchor) {
    if (window.CSAnalytics) {
      var eventName = 'Outbound Link Clicked';
      var clickProperties = this.getEventProperties(anchor);

      // if the anchor is loading in a new tab, we don't need anything fancy,
      // as our page will remain, and there's plenty of time to record the
      // event.
      if (Anchors.opensInNewTab(anchor)) {
        window.CSAnalytics(eventName, clickProperties);
      } else {
        // don't "click" the link
        event.preventDefault();

        // log the event
        window.CSAnalytics(eventName, clickProperties);

        // then, after a small delay, "click" the link.
        window.setTimeout(function() {
          window.location.href = anchor.href;
        }, 500);
      }
    }
  }

  getEventProperties(anchor) {
    var properties = {};

    if (this.props.eventProperties) {
      properties = this.props.eventProperties;
    }

    var clickProperties = Object.assign({}, properties);
    clickProperties.destination_url = anchor.href;


    return clickProperties;
  }

  render() {
    return (
      <div onClick={this.onClick}>
        {this.props.children}
      </div>
    );
  }
}


class VideoEmbeds extends React.Component {
  constructor(props) {
    super(props);

    this.container = React.createRef();
  }

  /**
   * Once the component has rendered, search "inside" it for any iframe video
   * embeds, and add our analytics tracking to them.
   */
  componentDidMount() {
    var container = this.container.current;

    var iframes = container.getElementsByTagName('iframe');
    if (iframes && iframes.length) {
      for (var i = 0; i < iframes.length; i++) {
        var tmp = iframes[i];

        if (AnalyticsUtil.VideoEmbeds.isVimeo(tmp)) {
          AnalyticsUtil.VideoEmbeds.VimeoFactory.initialise(
            tmp,
            this.props.eventProperties
          );
        }
        if (AnalyticsUtil.VideoEmbeds.isYouTube(tmp)) {
          AnalyticsUtil.VideoEmbeds.YouTubeFactory.initialise(
            tmp,
            this.props.eventProperties
          );
        }
      }
    }
  }

  render() {
    return (
      <div ref={this.container}>
        {this.props.children}
      </div>
    );
  }
}


/**
 * A simple helper component that simply includes all the Analytics wrapper
 * components. Useful in situations where we're embedding full article content,
 * which could include any type of content that we might want to track.
 */
class All extends React.Component {
  render() {
    return (
      <OutboundLinkTracker eventProperties={this.props.eventProperties}>
        <VideoEmbeds eventProperties={this.props.eventProperties}>
          {this.props.children}
        </VideoEmbeds>
      </OutboundLinkTracker>
    );
  }
}


var Analytics = {
  All: All,
  OutboundLinkTracker: OutboundLinkTracker,
  VideoEmbeds: VideoEmbeds
};


export default Analytics;

